export default __webpack_public_path__ + "static/media/043-turning torso.e3bd18d5.svg";